import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SiteContentContext = createContext(null);

// NOTE: Prices are intentionally NOT included in public defaults or the public /api/content
// response. All pricing is shown only on request (WhatsApp / email / call) per the
// owner's request to keep pricing off the public site.
const DEFAULTS = {
  hours: {
    umzinto: { weekday: 'Mon - Fri: 8:00 AM - 5:00 PM', saturday: 'Saturday: 8:00 AM - 2:00 PM', sunday: 'Sun & Holidays: Closed', gp_weekday: 'Mon - Fri: 10:00 AM - 5:00 PM', gp_saturday: 'Saturday: 8:00 AM - 2:00 PM (Full day)' },
    scottburgh: { weekday: 'Mon - Fri: 8:00 AM - 5:00 PM', saturday: 'Saturday: 8:00 AM - 2:00 PM', sunday: 'Sun & Holidays: Closed', gp_weekday: 'Mon - Fri: 8:00 AM - 10:00 AM', gp_saturday: '' }
  },
  contact: { phone: '039 974 1570', whatsapp: '082 895 1916', whatsapp_link: '27828951916', email: 'info@kkmedical.co.za' },
  promo: {
    hero_text: 'Quality healthcare. Personalised rates.',
    banner_text: 'Get a Quote',
    home_note: 'WhatsApp us for current rates'
  }
};

const FALLBACK_VALUE = { content: DEFAULTS, refresh: () => {} };

export const SiteContentProvider = ({ children }) => {
  const [content, setContent] = useState(DEFAULTS);

  const refresh = useCallback(() => {
    axios.get(`${API}/content`)
      .then(res => {
        const data = res.data || {};
        // Defensive: never allow prices to leak to the public site via context.
        const { prices: _prices, ...rest } = data;
        setContent(rest);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  // Memoize the value so children only re-render when content or refresh changes.
  const value = useMemo(() => ({ content, refresh }), [content, refresh]);

  return (
    <SiteContentContext.Provider value={value}>
      {children}
    </SiteContentContext.Provider>
  );
};

export const useSiteContent = () => {
  const ctx = useContext(SiteContentContext);
  return ctx || FALLBACK_VALUE;
};
